import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgHash02 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m9.5 3-3 18m11-18-3 18m6-13h-17m16 8h-17"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHash02)
export default ForwardRef
